// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-ac3a8ca2]{top:0}footer[data-v-ac3a8ca2],header[data-v-ac3a8ca2]{text-align:center;position:fixed;left:0;width:100%}footer[data-v-ac3a8ca2]{color:#ddd;font-size:12px;padding:16px;bottom:0}a[data-v-ac3a8ca2]{color:#eee;padding:8px 0}a[data-v-ac3a8ca2]:hover{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
